import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';

type EditDomainDialogProps = {
  id: string;
  domain: string;
  open: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
};

const EditDomainDialog: React.FC<EditDomainDialogProps> = ({ open, onClose, onSave, id, domain }) => {
  const { handleSubmit, control } = useForm();

  const onSubmit = (data: any) => {
    onSave({
      ...data,
      id,
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} sx={{ minWidth: '360px' }}>
      <DialogTitle>Edit Domain</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <Controller
            name="domain"
            control={control}
            defaultValue={domain}
            render={({ field }) => (
              <TextField
                {...field}
                label="Domain"
                fullWidth
                margin="normal"
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={onClose}>Cancel</Button>
          <Button type="submit" color="primary">Save</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EditDomainDialog;
